const CheckCircleIcon = ({
  size = 28,
  circleFill = '#2773C1',
  circleStroke = '#2773C1',
  checkStroke = '#FFFFFF',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16" cy="16" r="15" fill={circleFill} stroke={circleStroke} strokeWidth="2" />
    <path
      d="M9.5 17L13.5 21L22.5 12"
      stroke={checkStroke}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default CheckCircleIcon
